export default __webpack_public_path__ + "static/media/kedarnath1.979b8a02.jpg";